module.exports = __webpack_public_path__ + "img/icons-22.a5be6fd8.svg";